import React from 'react';
import FailedSvg from "../assets/FailedSvg";
import './noRoleDisclaimer.scss';
var NoRoleDisclaimer = function () {
    return (React.createElement("div", { className: 'sdds-banner no-role-disclaimer' },
        React.createElement("span", { className: "sdds-banner-prefix" },
            React.createElement(FailedSvg, null)),
        React.createElement("div", { className: "sdds-banner-body" },
            React.createElement("div", { className: "sdds-banner-header sdds-headline-05" }, "Access Denied"),
            React.createElement("div", { className: 'sdds-body-02' },
                "You do not seem to have access to CSTT. You can now request access via ",
                React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: 'https://scania.service-now.com/esc?id=sc_cat_item&sys_id=83687b84db34005050420e41ca961906' }, "SCANIA-NOW. "),
                React.createElement("br", null),
                "For any other access related issues, contact us on ",
                React.createElement("a", { href: "mailto:cstt.support@scania.com?subject=Access to CSTT" }, "cstt.support@scania.com"),
                "."))));
};
export default NoRoleDisclaimer;
